module.exports = __webpack_public_path__ + "static/media/vasta.cea50c3c.png";